// Libraries
import React from 'react';

// Supermove
import {MaintenancePage, SupermoveApp} from '@supermove/app';
import {StatusBar, UpdateChecker} from '@supermove/components';
import {usePersistCache, gql} from '@supermove/graphql';
import {useQuery} from '@supermove/hooks';
import {PersistentStorage, Environment} from '@supermove/sdk';
import {colors} from '@supermove/styles';

// App
import ErrorModal from 'modules/App/components/ErrorModal';

import {AppInfo, cache} from '../config';

const PersistWrapper = ({children}: {children: React.ReactNode}) => {
  // We're using the max Storage size of 50MB.
  const maxSize = 1024 * 1024 * 50;
  // @ts-expect-error TS(2740): Type 'InMemoryCache' is missing the following prop... Remove this comment to see the full error message
  const {isPersisted} = usePersistCache({cache, storage: PersistentStorage, maxSize});

  if (!isPersisted) {
    return null;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

const EstimatorAppContent = ({children}: {children: React.ReactNode}) => {
  const name = 'Estimator';
  const version = AppInfo.getVersion();
  const buildNumber = AppInfo.getBuildNumber();
  const {data} = useQuery(EstimatorApp.query, {fetchPolicy: 'cache-first'});

  return (
    <ErrorModal
      trigger={({handleOpen}: any) => (
        <SupermoveApp
          name={name}
          version={version}
          buildNumber={buildNumber}
          showOfflineOverlay={false}
          onError={(error) => {
            handleOpen();
          }}
          isAuthenticated={data?.isAuthenticated}
          viewer={data?.viewer}
        >
          <StatusBar barStyle={'light-content'} backgroundColor={colors.black} />
          <UpdateChecker name={name} buildNumber={buildNumber} pollInterval={1000 * 30}>
            {({isVisible}) => null}
          </UpdateChecker>
          <PersistWrapper>{children}</PersistWrapper>
        </SupermoveApp>
      )}
    />
  );
};

const EstimatorApp = ({router: Router}: {router: any}) => {
  const showMaintenancePage = Environment.get('SHOW_MAINTENANCE_PAGE');

  if (showMaintenancePage) {
    return <MaintenancePage />;
  }

  return (
    <EstimatorAppContent>
      <Router />
    </EstimatorAppContent>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
EstimatorApp.query = gql`
  ${SupermoveApp.fragment}

  query EstimatorApp {
    ${gql.query}
    isAuthenticated
    viewer {
      id
      ...SupermoveApp
    }
  }
`;

export default EstimatorApp;
